import React, { useState, useContext } from "react";
import "bootstrap/dist/css/bootstrap.css";
import AppContext from "../../context/AppContext";

import "../../constants/global.css";
import "./style/loginForm.css";
import ButtonRed from "../atoms/Button";
import InputForm from "../atoms/InputForm";
import { resendResetPasswordEmailAPI } from "../../api/facom_services";
import { LoadingFacom, ValidationAlert } from "../atoms";
import { removeTags } from "../../helpers/removeHtml";
import { LocalStorageKeys, setInLocalStorage } from "../../helpers/local-storage-manager";
import { useSelector } from "react-redux";

function RecoverPasswordForm(props) {
  const { profile } = useSelector((state) => state.profileReducer);
  const { language } = profile;
  const { content } = useContext(AppContext);
  const [emailRecover, setEmailRecover] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorValidationMessage, setErrorValidationMessage] = useState("");

  const resetPassword = async () => {
    setLoading(!loading);
    try {
      const response = resendResetPasswordEmailAPI(emailRecover);
      const data = (await response).data;
      if (!data.result?.migrated) {
        setInLocalStorage(LocalStorageKeys.EMAIL, "");
        setSuccess(true);
        setError(false);
      } else {
        setInLocalStorage(LocalStorageKeys.USER_ID, data.result?.uuid);
        window.location.replace(`/verify-identity`);
      }
    } catch (error) {
      console.log("error updated Password");
      console.log(error);
      if (language === "FR") {
        setErrorValidationMessage(
          `${error?.response?.data?.message}` === "You need to verify your email before login, please check your email inbox"
            ? "Vous devez vérifier votre adresse e-mail avant de vous connecter, veuillez vérifier votre boîte de réception"
            : `${error?.response?.data?.message}` === "user doesn't exists"
            ? "l'utilisateur n'existe pas"
            : `${error?.response?.data?.message}` ===
              "You need to verify your email before, please check your email inbox, and verify with the last one email"
            ? "Veuillez vérifier votre boîte de réception et activer votre compte pour vous connecter"
            : `${error?.response?.data?.message}`
        );
      } else {
        setErrorValidationMessage(`${error?.response?.data?.message}`);
      }
      setError(true);
      setSuccess(false);
    } finally {
      setLoading(false);
      console.log("end");
      // window.location.reload()
    }
  };
  const RenderError = () => {
    return (
      <>
        {error && (
          <div className="my-3">
            <ValidationAlert message={`${errorValidationMessage}`} variant="error" />
          </div>
        )}
      </>
    );
  };
  const RenderSuccess = () => {
    return (
      <>
        {success && (
          <div className="my-3">
            <ValidationAlert message={language === "EN" ? "Email sent" : "Email envoyé"} severity="success" />
          </div>
        )}
      </>
    );
  };

  return (
    <div className="col-12 bg-white">
      <h2 className="h2-stl  Center center__text">
        <div className="font__maxwidth">
          <div dangerouslySetInnerHTML={{ __html: content["FORGOT-PASSWORD-BOX.LOGIN-HOME.TITLE"] }} className="boxes-title spacing"></div>
        </div>
      </h2>
      <div className="line-loggin"></div>
      <div className="row">
        <div className="col-12 col-lg-4">
          <h4 className="h4-stl Rigth-l py-1">
            <div dangerouslySetInnerHTML={{ __html: content["FORGOT-PASSWORD-BOX.LOGIN-HOME.INPUT.EMAIL"] }}></div>
          </h4>
        </div>
        <div className="col-12 col-lg-8">
          <InputForm
            type="text"
            name="User"
            placeholder={removeTags(`${content["LOGIN-HOME-FORGOT-PASSWORD-BOX.INPUT.EMAIL-PLACEHOLDER"]}`)}
            style={{ heigth: "250px" }}
            currentValue={emailRecover}
            handleOnInputValue={(data) => {
              setEmailRecover(data);
            }}
          />
          <RenderSuccess />
          <RenderError />
          <div className="py-2"></div>
          <ButtonRed onClick={() => resetPassword()} message={removeTags(`${content["FORGOT-PASSWORD-BOX.LOGIN-HOME.BUTTON"]}`)} />
        </div>

        <div className="col-0 col-lg-2"></div>
      </div>
      {loading && <LoadingFacom />}
    </div>
  );
}

export default RecoverPasswordForm;
